export class GetDataCatalogSemanticLayerArtifactResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "url",
            "baseName": "url",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetDataCatalogSemanticLayerArtifactResponse.attributeTypeMap;
    }
    constructor() {
    }
}
